import React from 'react';

const FaqCommand = () => {
    return (
        <div className="overview-container">
            {/* ASCII Art Title */}
            <pre className="ascii-art">{`
███████╗ █████╗   ██████╗ 
██╔════╝██╔══██╗ ██╔═══██╗
█████╗  ███████║ ██║   ██║
██╔══╝  ██╔══██║ ██║▄▄ ██║
██║     ██║  ██║ ╚██████╔╝
╚═╝     ╚═╝  ╚═╝  ╚══▀▀═╝`}</pre>

            {/* Main Content Box */}
            <div className="content-box">
                <div className="box-header">
                    ❓❓ FREQUENTLY ASKED QUESTIONS ❓❓
                </div>

                <div className="box-content">
                    <section className="feature-section">
                        <h3>🤔🤔 What is AI Trader?</h3>
                        <p>
                            AI Trader is an innovative platform where you can earn AIDER tokens by
                            sharing your computer's power! Think of it as a fun twist on mining,
                            but for AI. Cool, right? 🚀💻
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>🔒🔒 Is it safe?</h3>
                        <p>
                            We employ top-notch security measures, and our code is open for
                            anyone to review. Your computer and investment are in good hands! 🛡️👍
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>💰💰 How much can I earn?</h3>
                        <p>
                            The sky's the limit! 🌟 As AI technology advances, so does the value
                            of AIDER. Some early participants have seen impressive returns!
                            Just remember, while crypto can be unpredictable, we're aiming high! 🚀🌕
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>🏦🏦 When will AIDER be on big exchanges?</h3>
                        <p>
                            We're actively working on getting AIDER listed on major exchanges. But hey,
                            buying now might be a smart move before it becomes more widely known! 😉📈
                        </p>
                    </section>

                    <section className="feature-section">
                        <h3>💸💸 How much should I invest?</h3>
                        <p>
                            The investment is fixed with purchase packages set at 0.05 BNB.
                            More AIDER means more involvement in our AI revolution.
                            Don't miss out on the AI party! 🎉🤖
                        </p>
                    </section>

                    <div className="disclaimer">
                        Remember: Cryptocurrency investments carry inherent risks. Always do your own research
                        and invest responsibly.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FaqCommand;